import React from "react";
import { Grid } from "@mui/material";

const ThreeQuarterColumn = ({ children }) => (
  <Grid size={{ xs: 9 ,md: 4}}>
    {children}
  </Grid>
);

export default ThreeQuarterColumn;
